

















import { Component, Prop, Vue } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'
import RichText from '@ivy/fts/comps/RichText.vue'

@Component({
  components: {
    RichText,
  },
})
export default class RewardIntroduce extends Vue {
  @Prop() rewardInfo: any
  list: any = []
  created() {
    this.list = this.rewardInfo.filter(Boolean)
  }
}
